module.exports = __webpack_public_path__ + "static/img/0_1_4.754fbcf6.jpg";